var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcAdherentsW(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.78 28.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.33,28.78c-.1,0-.2-.03-.28-.1l-2.5-2.02-2.51,2.02c-.16,.13-.4,.13-.56,0l-2.51-2.02-2.51,2.02c-.16,.13-.4,.13-.56,0l-2.51-2.02-2.5,2.02c-.17,.13-.4,.13-.56,0l-2.51-2.02-2.51,2.02c-.16,.13-.4,.13-.56,0l-2.51-2.02-2.5,2.02c-.13,.11-.32,.13-.48,.06-.15-.07-.26-.23-.26-.41V2.25C0,1.01,1.01,0,2.25,0H26.53c1.24,0,2.24,1.01,2.24,2.25V28.33c0,.17-.1,.33-.25,.41-.06,.03-.13,.04-.19,.04Zm-13.94-3.15c.1,0,.2,.03,.28,.1l2.51,2.02,2.51-2.02c.16-.13,.4-.13,.56,0l2.51,2.02,2.51-2.02c.16-.13,.4-.13,.56,0l2.06,1.66V2.25c0-.74-.61-1.35-1.35-1.35H2.25c-.74,0-1.35,.6-1.35,1.35V27.39l2.05-1.66c.17-.13,.4-.13,.56,0l2.51,2.02,2.51-2.02c.16-.13,.4-.13,.56,0l2.51,2.02,2.51-2.02c.08-.06,.18-.1,.28-.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.83,14.84h-3.6c-.25,0-.45-.2-.45-.45s.2-.45,.45-.45h3.6c.25,0,.45,.2,.45,.45s-.2,.45-.45,.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.83,11.24h-3.6c-.25,0-.45-.2-.45-.45s.2-.45,.45-.45h3.6c.25,0,.45,.2,.45,.45s-.2,.45-.45,.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.83,7.64h-3.6c-.25,0-.45-.2-.45-.45s.2-.45,.45-.45h3.6c.25,0,.45,.2,.45,.45s-.2,.45-.45,.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.83,21.36H4.95c-.37,0-.67-.3-.67-.67s.3-.67,.67-.67H23.83c.37,0,.67,.3,.67,.67s-.3,.67-.67,.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M17.43,16c-.19,0-.39-.13-.39-.39,0,0-.13-1.69-1.3-2.34l-2.47-1.04c-1.23,.45-2.53,.45-3.76,0l-2.47,1.04c-1.17,.58-1.3,2.27-1.3,2.34,0,.19-.19,.39-.39,.39s-.39-.19-.39-.39c0-.06,.13-2.14,1.69-2.98h0l2.66-1.1c.13-.06,.19-.06,.32,0,1.1,.45,2.34,.45,3.44,0,.13-.06,.19-.06,.32,0l2.66,1.1h0c1.62,.78,1.69,2.86,1.69,2.98,.06,.19-.06,.39-.32,.39q.06,0,0,0h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "f",
    d: "M12.57,10.74c-.19,0-.39-.19-.39-.39,0-.13,.06-.26,.19-.32,.91-.58,.97-.91,1.04-1.88v-.19c.13-.52,.06-1.04-.13-1.56-.26-.39-.58-.71-1.04-.84-.52-.19-1.1-.19-1.62,0-.45,.13-.84,.45-1.04,.84-.19,.52-.26,1.04-.13,1.56v.19c.13,.91,.13,1.23,1.04,1.88,.19,.13,.19,.32,.13,.52s-.32,.19-.52,.13h0c-.91-.45-1.43-1.43-1.36-2.4v-.19c-.13-.65-.06-1.36,.26-2.01,.32-.58,.84-1.04,1.49-1.23,.65-.19,1.43-.19,2.08,0s1.17,.65,1.49,1.23c.26,.65,.39,1.3,.26,2.01v.19c0,.97-.52,1.95-1.36,2.4-.26,0-.32,.06-.39,.06Z",
    style: {
      fill: "#fff"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAdherentsW);
export default __webpack_public_path__ + "static/media/ic-adherents-w.c967b223f0230cb6b442c8018aca5085.svg";
export { ForwardRef as ReactComponent };